var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timeline"},_vm._l((_vm.totalStep),function(step){return _c('div',{key:step,staticClass:"step",class:{'current-step': _vm.currentStep === step},style:(("width: calc(100% / " + _vm.totalStep + ")"))},[_c('div',{staticClass:"dot",attrs:{"data-step":step}})])}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa6d90c0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Timeline.vue
// module id = 901
// module chunks = 1